export const AdSlot = ({ id, className = "" }) => (
  <aside
    data-testid={`ad-slot-${id}`}
    aria-label="Advertisement"
    className={`border border-dashed border-white/15 bg-white/[0.02] py-8 px-6 text-center select-none ${className}`}
  >
    <p className="font-mono-ls text-[10px] tracking-[0.3em] uppercase text-zinc-500">Advertisement</p>
  </aside>
);
